import { useEffect, useState } from "react";
import {
  addNDays,
  date2FormattedString,
  date2String,
  datetime2FormattedString,
  getDateRange,
  string2Datetime,
} from "../../utils/utils";
import { getBatterySoCFlow, getPowerFlow } from "../../utils/flowhistoryutils";

const MAXDAYS = 2 * 7;

export default function useHourlyFlowDownloader(
  defaultDate,
  locationClient,
  showMsg = null,
) {
  const [exportStartDate, setExportStartDate] = useState(defaultDate);
  const [exportEndDate, setExportEndDate] = useState(defaultDate);

  useEffect(() => {
    if (exportStartDate > exportEndDate) setExportEndDate(exportStartDate);
  }, [exportStartDate]);

  useEffect(() => {
    setExportStartDate(defaultDate);
    setExportEndDate(defaultDate);
  }, [defaultDate]);

  const syncFlow = async (date) =>
    locationClient.getHourlyFlow({ date: date2String(date), sync: true });

  const getExcelData = async () => {
    if (addNDays(exportStartDate, MAXDAYS) < exportEndDate) {
      showMsg?.(
        `Daten von maximal ${MAXDAYS} Tagen können gleichzeitig exportiert werden.`,
        "error",
      );
      return;
    }
    const dates = getDateRange(exportStartDate, exportEndDate);
    return Promise.all(
      dates.map(async (date) => {
        const response = await syncFlow(date);
        return createExcelSheet(date, response.data);
      }),
    );
  };

  const createExcelSheet = (date, flow) => {
    const powerFlow = { ...getPowerFlow(flow), ...getBatterySoCFlow(flow) };
    const header = ["Zeit", ...Object.values(powerFlow)];
    const rows = flow.time.map((t) => [
      datetime2FormattedString(string2Datetime(t)),
    ]);
    Object.keys(powerFlow).forEach((key) => {
      flow[key].forEach((val, idx) => rows[idx].push(val));
    });
    return { name: date2FormattedString(date), data: [header, ...rows] };
  };

  const filename = !(exportStartDate && exportEndDate)
    ? `Energiefluesse`
    : date2String(exportStartDate) === date2String(exportEndDate)
      ? `Energiefluesse-${date2String(exportStartDate)}`
      : `Energiefluesse-${date2String(exportStartDate)}-${date2String(
          exportEndDate,
        )}`;
  const disabled = !(
    exportStartDate &&
    exportEndDate &&
    exportEndDate >= exportStartDate
  );

  return {
    date: {
      start: { value: exportStartDate, setValue: setExportStartDate },
      end: {
        value: exportEndDate,
        setValue: setExportEndDate,
        min: exportStartDate,
        max: addNDays(exportStartDate, MAXDAYS),
      },
    },
    excelExport: { getData: getExcelData, filename, disabled },
  };
}
